import React from "react";

/**
 *
 * @param {Number|string} id
 * @param {Element} children
 * @param {string|Element} separator
 * @returns {React.JSX.Element}
 * @constructor
 */
export const Separated = ({ id, children, separator = " | " }) => {
  return (
    <React.Fragment>
      {React.Children.toArray(children)
        .reduce((previousValue, currentValue, idx) => {
          const sep = {
            ...separator,
            key: `sep-${idx}-${id}`,
          };
          return [...previousValue, currentValue, sep];
        }, [])
        .slice(0, -1)}
    </React.Fragment>
  );
};

export default Separated;
